function _extends() {_extends = Object.assign ? Object.assign.bind() : function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends.apply(this, arguments);}import { Action } from "../Action";
import { AccountOutlineIcon } from "../Icons";
import palette from "../theme/shared/palette";
import * as React from 'react';
import { useContext, useMemo } from 'react';
import { ThemeContext } from 'styled-components';
import { CircleAttentionIcon, CircleTickIcon } from "./styles";


export const TopSection = ({
  actionProps,
  userName,
  accountEmail,
  isAccountVerified,
  isAccountIncomplete,
  profileButtonText }) =>
{
  const theme = useContext(ThemeContext);

  const circleBadgeProps = useMemo(
  () => {
    if (isAccountIncomplete) {
      return {
        hasCircleBadge: true,
        circleBadgeColor: theme.colors.ElementBackground,
        circleBadgeIcon: /*#__PURE__*/React.createElement(CircleAttentionIcon, { size: 20, color: theme.colors.caution }),
        circleBorderColor: palette.yolk[50] };

    }

    if (isAccountVerified) {
      return {
        hasCircleBadge: true,
        circleBadgeColor: theme.colors.ElementBackground,
        circleBadgeIcon: /*#__PURE__*/React.createElement(CircleTickIcon, { size: 20, color: theme.colors.positive }),
        circleBorderColor: palette.broccoli[25] };

    }

    return undefined;
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [isAccountVerified, isAccountIncomplete]);


  return /*#__PURE__*/(
    React.createElement(Action, _extends({},
    actionProps,
    circleBadgeProps, {
      icon: /*#__PURE__*/React.createElement(AccountOutlineIcon, { color: theme.colors.secondary }),
      title: userName,
      description: accountEmail,
      hasAdditionalButton: true,
      additionalButtonText: profileButtonText })));


};